import React from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./navigation";
import { store } from "./modules/redux/store";
import { Provider } from "react-redux";
import { mergeStyles } from "@fluentui/react";
import { colorPallete } from "./assets/color";
import { ThirdPartyCookiesWarning } from "./thirdPartyWarning/index";
import { areThirdPartyCookiesBlocked } from "./thirdPartyWarning/detectPrivateMode";
import { useState } from "react";
import { useEffect } from "react";
import { UploadNotificationProvider } from "./context/UploadNotificationContext";
function App() {
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    areThirdPartyCookiesBlocked().then(setShowWarning);
  }, []);
  return (
    <Provider store={store}>
      <UploadNotificationProvider>
      {showWarning && <ThirdPartyCookiesWarning />}
      <BrowserRouter>
        <div style={{ ...styles.whiteWrapper, position: "absolute" }}></div>
        <div style={{ ...styles.greyWrapper, position: "absolute" }}></div>
        <div data-testid="app-container" className={mergeStyles(styles.top)}>
          <div className={mergeStyles(styles.container)}>
            <AppRoutes />
          </div>
        </div>
      </BrowserRouter>
      </UploadNotificationProvider>
    </Provider>
  );
}

export default App;

const styles = {
  top: {
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "",
    height: "100vh",
    display: "flex",
  },
  container: {
    maxWidth: 1238,
    width: "91%",
    backgroundColor: "",
    marginVertical: 0,
    marginHorizontal: "auto",
    height: "100vh",
  },
  whiteWrapper: {
    backgroundColor: "white",
    marginBottom: "2%",
    height: "70px",
    width: "100%",
    zIndex: -6,
    top: 0,
  },
  greyWrapper: {
    background: "linear-gradient(90deg, #ECF0F9 0%, #EFECF9 100%)",
    marginBottom: "2%",
    height: "95px",
    width: "100%",
    zIndex: -9,
    top: 70,
  },
};
